import React from "react";

export default function ML_Testing() {
  return (
    <div>
      <h1>ML_Testing</h1>
      <p>This is the ML_Testing component.</p>
    </div>
  );
}
